var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadingVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_263_934",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 3H6.5C5.57174 3 4.6815 3.36875 4.02513 4.02513C3.36875 4.6815 3 5.57174 3 6.5V41.5C3 42.4283 3.36875 43.3185 4.02513 43.9749C4.6815 44.6312 5.57174 45 6.5 45H41.5C42.4283 45 43.3185 44.6312 43.9749 43.9749C44.6312 43.3185 45 42.4283 45 41.5V6.5C45 5.57174 44.6312 4.6815 43.9749 4.02513C43.3185 3.36875 42.4283 3 41.5 3Z",
    stroke: "white",
    strokeWidth: 4.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9167 28.6671V21.5947L26.0417 25.1297L32.1667 28.6671L26.0417 32.2032L19.9167 35.7394V28.6671Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.5H45M34.5 3L27.5 13.5M20.5 3L13.5 13.5",
    stroke: "white",
    strokeWidth: 4.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_263_934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4 -4H52V52H-4V-4Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadingVideoIcon);
export default __webpack_public_path__ + "static/media/uploading_video_icon.369f4270038b9bbd75c7386752d2c325.svg";
export { ForwardRef as ReactComponent };